import { TextareaField } from "@ps-design-system/components/Textarea";

import { useIntl } from "react-intl-compat";

/** General rules text. */
const GeneralRulesField = () => {
  const intl = useIntl();

  return (
    <TextareaField
      fullWidth
      name="rules"
      label={intl.formatMessage({
        id: "hosting.listing_rules.rules_label",
        defaultMessage: "General rules",
      })}
      testId="rules-form-rules-input"
    />
  );
};

export { GeneralRulesField };
